"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SurveyQuestionTypesEnum = void 0;
var SurveyQuestionTypesEnum = /*#__PURE__*/function (SurveyQuestionTypesEnum) {
  SurveyQuestionTypesEnum[SurveyQuestionTypesEnum["OPEN"] = 1] = "OPEN";
  SurveyQuestionTypesEnum[SurveyQuestionTypesEnum["SELECT"] = 2] = "SELECT";
  SurveyQuestionTypesEnum[SurveyQuestionTypesEnum["MULTISELECT"] = 3] = "MULTISELECT";
  SurveyQuestionTypesEnum[SurveyQuestionTypesEnum["SELECT_DROPDOWN"] = 4] = "SELECT_DROPDOWN";
  SurveyQuestionTypesEnum[SurveyQuestionTypesEnum["PRESCRIPTION"] = 5] = "PRESCRIPTION";
  SurveyQuestionTypesEnum[SurveyQuestionTypesEnum["ALLERGIES"] = 6] = "ALLERGIES";
  return SurveyQuestionTypesEnum;
}({});
exports.SurveyQuestionTypesEnum = SurveyQuestionTypesEnum;